module.exports = __webpack_public_path__ + "static/media/ClotheSizeGuide.42b8db43.jpg";